import createTipoNovedadForm from './createTipoNovedadFormModel';
const {
  formField: {
    // DATOS PARAMETROS
    name,
    description,
    accion_1,
    resultado_1,
    cantidad_1,
    accion_2,
    resultado_2,
    cantidad_2,
    accion_3,
    resultado_3,
    cantidad_3,
    accion_4,
    resultado_4,
    cantidad_4,
  },
} = createTipoNovedadForm;

export default {
  [name.name]: '',
  [description.name]: '',
  [accion_1.name]: '',
  [resultado_1.name]: '',
  [cantidad_1.name]: '',
  [accion_2.name]: '',
  [resultado_2.name]: '',
  [cantidad_2.name]: '',
  [accion_3.name]: '',
  [resultado_3.name]: '',
  [cantidad_3.name]: '',
  [accion_4.name]: '',
  [resultado_4.name]: '',
  [cantidad_4.name]: '',
};
